// Utility functions for formatting dates, numbers, and other display data

/**
 * Format date to Thai locale
 */
export const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

/**
 * Format date to short format
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  return date.toLocaleDateString("th-TH", {
    month: "short",
    day: "numeric",
  });
};

/**
 * Format number with thousand separator
 */
export const formatNumber = (number) => {
  if (number === null || number === undefined) return "0";
  return number.toLocaleString("th-TH");
};

/**
 * Format number to fixed decimal places
 */
export const formatDecimal = (number, decimals = 1) => {
  if (number === null || number === undefined) return "0";
  return number.toFixed(decimals);
};

/**
 * Format percentage
 */
export const formatPercentage = (number, decimals = 1) => {
  if (number === null || number === undefined) return "0%";
  return `${number.toFixed(decimals)}%`;
};

/**
 * Format currency (Thai Baht)
 */
export const formatCurrency = (number) => {
  if (number === null || number === undefined) return "0.00 บาท";
  const num = Number(number);
  if (isNaN(num)) return "0.00 บาท";
  return `${num.toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท`;
};

/**
 * Get today's date in YYYY-MM-DD format
 */
export const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Get seat utilization color class based on percentage
 */
export const getSeatUtilizationColor = (utilization) => {
  if (utilization > 70) {
    return "bg-green-100 text-green-800";
  } else if (utilization >= 40) {
    return "bg-yellow-100 text-yellow-800";
  } else {
    return "bg-red-100 text-red-800";
  }
};

/**
 * Get weekday name in Thai
 */
export const getWeekdayName = (dayIndex) => {
  const weekdays = {
    0: "อาทิตย์",
    1: "จันทร์",
    2: "อังคาร",
    3: "พุธ",
    4: "พฤหัสบดี",
    5: "ศุกร์",
    6: "เสาร์",
  };
  return weekdays[dayIndex] || "-";
};

/**
 * Truncate text with ellipsis
 */
export const truncateText = (text, maxLength) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};
